var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitchoff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 102,
    viewBox: "0 0 111 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_8040_11203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0092 38.8339C31.7193 31.1073 37.748 24.6088 45.4745 24.3189L63.0807 23.6585C70.8072 23.3686 77.3058 29.3973 77.5957 37.1238L78.2561 54.73C78.546 62.4565 72.5173 68.9551 64.7908 69.2449L47.1846 69.9054C39.4581 70.1952 32.9595 64.1666 32.6696 56.44L32.0092 38.8339Z",
    fill: "url(#paint0_linear_8040_11203)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_8040_11203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0092 38.8339C31.7193 31.1073 37.748 24.6088 45.4745 24.3189L63.0807 23.6585C70.8072 23.3686 77.3058 29.3973 77.5957 37.1238L78.2561 54.73C78.546 62.4565 72.5173 68.9551 64.7908 69.2449L47.1846 69.9054C39.4581 70.1952 32.9595 64.1666 32.6696 56.44L32.0092 38.8339Z",
    fill: "url(#paint1_linear_8040_11203)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.036 40.1903L50.7476 40.5012C47.3144 40.63 44.6319 43.4188 44.7562 46.7302C44.8804 50.0415 47.7642 52.6215 51.1974 52.4927L59.4859 52.1818C62.919 52.053 65.6015 49.2642 65.4773 45.9528C65.3531 42.6415 62.4692 40.0615 59.036 40.1903Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0502 48.4898C52.1946 48.4468 53.0887 47.5172 53.0473 46.4134C53.0059 45.3097 52.0446 44.4497 50.9002 44.4926C49.7558 44.5355 48.8617 45.4651 48.9031 46.5689C48.9445 47.6727 49.9058 48.5327 51.0502 48.4898Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_8040_11203)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_8040_11203",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.616 27.7866C65.4872 24.3535 68.166 21.4659 71.5991 21.3371C75.0323 21.2083 77.9199 23.8871 78.0487 27.3203C78.1775 30.7534 75.4987 33.641 72.0655 33.7698C68.6323 33.8986 65.7448 31.2198 65.616 27.7866Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.616 27.7866C65.4872 24.3535 68.166 21.4659 71.5991 21.3371C75.0323 21.2083 77.9199 23.8871 78.0487 27.3203C78.1775 30.7534 75.4987 33.641 72.0655 33.7698C68.6323 33.8986 65.7448 31.2198 65.616 27.7866Z",
    fill: "url(#paint2_linear_8040_11203)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.616 27.7866M78.0487 27.3203M78.0487 27.3203M65.616 27.7866M71.5991 21.3371M78.0487 27.3203M72.0655 33.7698M65.616 27.7866M72.0655 33.7698L71.9906 31.7712C69.6612 31.8586 67.702 30.0411 67.6146 27.7117L65.616 27.7866L63.6174 27.8616C63.7876 32.3986 67.6035 35.9386 72.1405 35.7684L72.0655 33.7698ZM78.0487 27.3203L76.0501 27.3952C76.1375 29.7246 74.3199 31.6838 71.9906 31.7712L72.0655 33.7698L72.1405 35.7684C76.6775 35.5982 80.2175 31.7823 80.0473 27.2453L78.0487 27.3203ZM71.5991 21.3371L71.6741 23.3357C74.0035 23.2483 75.9627 25.0658 76.0501 27.3952L78.0487 27.3203L80.0473 27.2453C79.8771 22.7083 76.0611 19.1683 71.5242 19.3385L71.5991 21.3371ZM71.5991 21.3371L71.5242 19.3385C66.9872 19.5087 63.4472 23.3246 63.6174 27.8616L65.616 27.7866L67.6146 27.7117C67.5272 25.3823 69.3447 23.4231 71.6741 23.3357L71.5991 21.3371Z",
    fill: "white",
    mask: "url(#path-5-inside-1_8040_11203)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8040_11203",
    x: -0.515625,
    y: -8.86719,
    width: 111.297,
    height: 111.297,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_8040_11203"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_8040_11203",
    x: 19.4844,
    y: 21.1328,
    width: 71.2969,
    height: 71.2969,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8040_11203"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8040_11203"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_8040_11203"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8040_11203",
    result: "effect2_dropShadow_8040_11203"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8040_11203",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_8040_11203",
    x: 53.3828,
    y: 19.1016,
    width: 36.8984,
    height: 36.8984,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8040_11203"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8040_11203"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_8040_11203"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8040_11203",
    result: "effect2_dropShadow_8040_11203"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8040_11203",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8040_11203",
    x1: 31.4844,
    y1: 24.8438,
    x2: 78.7809,
    y2: 68.7201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E51FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8200DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8040_11203",
    x1: 31.4844,
    y1: 24.8438,
    x2: 78.7809,
    y2: 68.7201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E51FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8200DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8040_11203",
    x1: 65.3828,
    y1: 21.5703,
    x2: 78.2819,
    y2: 33.5366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E51FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8200DB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchoff);
export default __webpack_public_path__ + "static/media/Switch off.935084b623979f6b154d1f85b35bbc76.svg";
export { ForwardRef as ReactComponent };